import { __assign, __awaiter, __generator } from "tslib";
import { ChannelType } from './agent';
export var JobState;
(function (JobState) {
    JobState["Distribute"] = "distribute";
    JobState["Offering"] = "offering";
    JobState["Bridged"] = "bridged";
    JobState["Missed"] = "missed";
    JobState["Processing"] = "processing";
    JobState["Closed"] = "closed";
    JobState["Destroy"] = "destroy";
})(JobState || (JobState = {}));
export var ChannelName;
(function (ChannelName) {
    ChannelName["Call"] = "call";
    ChannelName["Chat"] = "chat";
    ChannelName["Task"] = "task";
})(ChannelName || (ChannelName = {}));
var Task = /** @class */ (function () {
    function Task(client, e, distribute) {
        this.client = client;
        this.distribute = distribute;
        this.id = e.attempt_id;
        this.state = JobState.Offering;
        this.setState(e.status);
        this.lastStatusChange = e.timestamp;
        this.createdAt = e.timestamp;
        this._processing = null;
        this.offeringAt = 0;
        this.answeredAt = 0;
        this.bridgedAt = 0;
        this.reportedAt = 0;
        this.startProcessingAt = 0;
        this.stopAt = 0;
        this.closedAt = 0;
        this.form = null;
        this.autoAnswered = false;
        this._autoAnswerParam = false;
        this._autoAnswerTimerId = null;
        this.communication = distribute.communication;
        this.history = [distribute];
    }
    Object.defineProperty(Task.prototype, "queue", {
        get: function () {
            return {
                id: this.distribute.queue_id,
                name: this.distribute.queue_name,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "duration", {
        get: function () {
            return Math.round((Date.now() - this.lastStatusChange) / 1000);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "hasForm", {
        get: function () {
            return this.distribute.has_form || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "channel", {
        get: function () {
            return this.distribute.channel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "allowAccept", {
        get: function () {
            return (this.channel === ChannelName.Task &&
                (this.bridgedAt === 0 && this.closedAt === 0));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "allowDecline", {
        get: function () {
            return this.allowAccept;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "allowClose", {
        get: function () {
            return (this.channel === ChannelName.Task &&
                this.closedAt === 0 &&
                this.bridgedAt > 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "memberId", {
        get: function () {
            return this.distribute.member_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "queueId", {
        get: function () {
            return this.distribute.queue_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "hasReporting", {
        get: function () {
            return this.distribute.has_reporting;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "allowReporting", {
        get: function () {
            return this.hasReporting && this.bridgedAt > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "agentChannelId", {
        get: function () {
            return this.distribute.agent_channel_id;
        },
        enumerable: false,
        configurable: true
    });
    // todo
    Task.prototype.setState = function (state) {
        this.state = state;
    };
    Task.prototype.setAnswered = function (t) {
        this.answeredAt = t;
        this.lastStatusChange = Date.now();
        if (this._autoAnswerTimerId) {
            clearTimeout(this._autoAnswerTimerId);
            this._autoAnswerTimerId = null;
        }
    };
    Task.prototype.setOffering = function (e) {
        var _this = this;
        this.offeringAt = e.timestamp;
        if (e.offering.auto_answer && this.channel === ChannelType.Job) {
            this._autoAnswerParam = e.offering.auto_answer;
            this.acceptDelay().catch(function (err) {
                _this.client.emit('error', err);
            });
        }
    };
    Task.prototype.setBridged = function (e) {
        this.bridgedAt = e.timestamp;
        this.lastStatusChange = Date.now();
        if (e.form) {
            this.form = e.form;
        }
        if (this._autoAnswerTimerId) {
            clearTimeout(this._autoAnswerTimerId);
            this._autoAnswerTimerId = null;
        }
    };
    Task.prototype.setProcessing = function (now, p) {
        this.state = JobState.Processing;
        this.closedAt = now;
        if (!this.startProcessingAt) {
            this.startProcessingAt = Date.now();
        }
        if (p.sec && !p.timeout) {
            p.timeout = Date.now() + p.sec * 1000; // bug
        }
        this._processing = p;
    };
    Task.prototype.setClosed = function (now) {
        this.stopAt = now;
        this.state = JobState.Closed;
    };
    Task.prototype.setTransferred = function (d) {
        this.distribute = d;
        this.history.push(d);
    };
    Task.prototype.setMissed = function () {
        this.state = JobState.Missed;
    };
    Object.defineProperty(Task.prototype, "processingTimeoutAt", {
        get: function () {
            if (!this._processing || !this._processing.timeout) {
                return null;
            }
            return this._processing.timeout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "processingSec", {
        get: function () {
            if (!this._processing || !this._processing.sec) {
                return null;
            }
            return this._processing.sec;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "attempt", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "variables", {
        get: function () {
            var res = {};
            for (var k in this.distribute.variables) {
                if (k.startsWith('cc_')) {
                    continue;
                }
                res[k] = this.distribute.variables[k];
            }
            return res;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "isMember", {
        get: function () {
            return !!this.memberId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "displayNumber", {
        get: function () {
            return this.communication.destination;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "displayName", {
        get: function () {
            return this.distribute.member_name || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "display", {
        get: function () {
            return this.displayName + " (" + this.displayNumber + ")";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "renewalSec", {
        get: function () {
            if (!this._processing || !this._processing.renewal_sec) {
                return null;
            }
            return this._processing.renewal_sec;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "autoAnswer", {
        get: function () {
            return this.autoAnswerDelay > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Task.prototype, "autoAnswerDelay", {
        get: function () {
            if (!this._autoAnswerParam || "" + this._autoAnswerParam === 'false') {
                return 0;
            }
            else if (isFinite(+this._autoAnswerParam)) {
                return +this._autoAnswerParam;
            }
            return this.client.autoAnswerDelayTime;
        },
        enumerable: false,
        configurable: true
    });
    /*
      control
     */
    Task.prototype.accept = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request("cc_agent_task_accept", {
                        agent_id: this.distribute.agent_id,
                        attempt_id: this.id,
                        app_id: this.distribute.app_id,
                    })];
            });
        });
    };
    Task.prototype.acceptDelay = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this._autoAnswerTimerId = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (this.autoAnswered) {
                                    return [2 /*return*/];
                                }
                                if (!!this.answeredAt) return [3 /*break*/, 2];
                                this.autoAnswered = true;
                                return [4 /*yield*/, this.accept()];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); }, this.autoAnswerDelay);
                return [2 /*return*/];
            });
        });
    };
    Task.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request("cc_agent_task_close", {
                        agent_id: this.distribute.agent_id,
                        attempt_id: this.id,
                        app_id: this.distribute.app_id,
                    })];
            });
        });
    };
    // todo
    Task.prototype.decline = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request("cc_agent_task_close", {
                        agent_id: this.distribute.agent_id,
                        attempt_id: this.id,
                        app_id: this.distribute.app_id,
                    })];
            });
        });
    };
    Task.prototype.reporting = function (reporting) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request('cc_reporting', __assign({ attempt_id: this.id }, reporting))];
                    case 1:
                        res = _a.sent();
                        this.reportedAt = Date.now();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    Task.prototype.renew = function (sec) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.request('cc_renewal', {
                        attempt_id: this.id,
                        renewal_sec: sec ? sec : this.processingSec,
                    })];
            });
        });
    };
    Task.prototype.formAction = function (action, fields) {
        return __awaiter(this, void 0, void 0, function () {
            var res, _i, _a, _b, key, value;
            return __generator(this, function (_c) {
                if (!this.form) {
                    throw new Error('not found active form');
                }
                res = {};
                for (_i = 0, _a = Object.entries(fields); _i < _a.length; _i++) {
                    _b = _a[_i], key = _b[0], value = _b[1];
                    if (typeof value === 'object') {
                        ;
                        res[key] = JSON.stringify(value);
                    }
                    else {
                        ;
                        res[key] = value;
                    }
                }
                return [2 /*return*/, this.client.request('cc_form_action', {
                        attempt_id: this.id,
                        app_id: this.distribute.app_id,
                        action: action,
                        fields: res,
                    })];
            });
        });
    };
    return Task;
}());
export { Task };
//# sourceMappingURL=task.js.map